import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CompanySelector from '../../components/admin/CompanySelector';
import Meta from '../../components/layout/Meta';

const CompanySelectScreen = () => {
    const { activeCompany } = useSelector((state) => state.admin);
    const { userInfo } = useSelector((state) => state.auth);
    const navigate = useNavigate();

    useEffect(() => {
        if (activeCompany) {
            navigate('/admin/productlist');
        }
    }, [activeCompany, navigate]);

    if (!userInfo || !userInfo.isAdmin) {
        navigate('/login');
        return null;
    }

    return (
        <Container>
            <Meta title="Seleccionar Empresa" />
            <Row className="justify-content-md-center mt-5">
                <Col xs={12} md={6}>
                    <Card className="shadow-sm border-0 p-4">
                        <Card.Body>
                            <h2 className="text-center mb-4">Seleccionar Empresa</h2>
                            <p className="text-muted text-center mb-4">
                                Para continuar como administrador, por favor selecciona la empresa que deseas gestionar.
                            </p>
                            <div className="d-flex justify-content-center">
                                <CompanySelector />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default CompanySelectScreen;
